export interface Environment {
  production: boolean;
  serverUrl: string;
  assetDownloadBaseUrl: string;
  defaultClientId: string;
  defaultClientSecret: string;
  enableDebugMode: boolean;
  logLevel: 'error' | 'warn' | 'info' | 'debug';
  reconnectInterval: number;
  maxReconnectAttempts: number;

  // --- Asset prefetching -------------------------------------------------

  /** How many assets are downloaded at the same time. */
  prefetchConcurrency: number;
  /** Assets that must be cached before playback starts; the rest keep loading in the background. */
  prefetchLookahead: number;
  /** Upper bound for the in-memory blob cache. Beyond this, assets stream from the hub instead. */
  maxCacheBytes: number;
  /** Give up on a single asset download after this long. */
  assetFetchTimeoutMs: number;
  /** If a video/audio has not started within this window, treat it as failed and move on. */
  mediaStartTimeoutMs: number;
}

export const environment: Environment = {
  production: false,
  serverUrl: 'ws://localhost:7000',
  assetDownloadBaseUrl: 'http://localhost:5000/api',
  // serverUrl: 'wss://hub.winsignage.com:443',
  // assetDownloadBaseUrl: 'https://hub.winsignage.com/api',
  defaultClientId: 'CBXMWZJ4',
  defaultClientSecret: '045XNQL3',
  enableDebugMode: true,
  logLevel: 'debug',
  reconnectInterval: 5000, // 5 seconds
  maxReconnectAttempts: 10,

  prefetchConcurrency: 3,
  prefetchLookahead: 1,
  maxCacheBytes: 512 * 1024 * 1024, // 512 MB
  assetFetchTimeoutMs: 60000,
  mediaStartTimeoutMs: 20000,
};
